<template>
  <div style="border: 1px solid backe; overflow: visible;">
    <div class="pdf-center" style="border: 1px solid backe; overflow: visible;">
      <button @click="exportToPDF" class="btn btn-primary">{{ buttonContent }}</button>
      <b-form-checkbox
        class="form-checkbox"
        v-model="isname2"
        :value="true"
        :unchecked-value="false"
        switch
        style="margin-left: 1.6rem;"
      >
        <span class="select_text">Name2</span>
      </b-form-checkbox>
    </div>
    <hr style="margin: .5rem 0;"/>
    <div id="pdf-content" ref="pdfContent" class="pdf-container">
      <h2 class="pdf-center">Deplicate</h2>
      <div class="pdf-center">{{ rowdata.name }}</div>
      <div class="pdf-center">{{ rowdata.addr }}</div>
      <div class="pdf-center">{{ rowdata.city }}</div>
      <div class="pdf-center">{{ rowdata.tel }}</div>
      <div class="pdf-center">{{ rowdata.taxno }}</div>
      <h2 class="pdf-center text-left">{{ rowdata.tableno }}</h2>
      <hr class="pdf-liner" />
      <table class="table">
        <tbody>
          <tr>
            <td class="col-50 text-left">{{ rowdata.date }}</td>
            <td class="col-50 text-right">{{ rowdata.time }}</td>
          </tr>
          <tr>
            <td class="col-50 text-left">Type:</td>
            <td class="col-50 text-right">{{ rowdata.type }}</td>
          </tr>
          <tr>
            <td class="col-50 text-left">Terminal:</td>
            <td class="col-50 text-right">{{ rowdata.terminal }}</td>
          </tr>
          <tr>
            <td class="col-50 text-left">Cashier:</td>
            <td class="col-50 text-right">{{ rowdata.cashier }}</td>
          </tr>
          <tr>
            <td class="col-50 text-left">Invoice#:</td>
            <td class="col-50 text-right">{{ rowdata.invoiceno }}</td>
          </tr>
        </tbody>
      </table>
      <hr class="pdf-liner" />
      <table class="table">
        <thead>
          <tr>
            <th class="col-id">Qty</th>
            <th class="col-name">Item</th>
            <th class="col-score text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rowdata.items" :key="index">
            <td class="col-id">{{ item.qty }}</td>
            <td v-if="isname2" class="col-name">{{ item.name2 }}</td>
            <td v-else class="col-name">{{ item.name }}</td>
            <td class="col-score text-right">{{ item.amount }}</td>
          </tr>
        </tbody>
      </table>
      <hr class="pdf-liner2" />
      <table class="table">
        <tbody>
          <tr v-for="(item, index) in rowdata.totals" :key="index">
            <td v-if="isname2" class="col-50 text-left">{{ item.name2 }}</td>
            <td v-else class="col-50 text-left">{{ item.name }}</td>
            <td class="col-50 text-right">{{ item.amount }}</td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <thead>
          <tr>
            <td v-if="isname2" class="col-50 text-left"><h2>总计:</h2></td>
            <td v-else class="col-50 text-left"><h2>Total:</h2></td>
            <td class="col-50 text-right"><h2>{{ rowdata.total }}</h2></td>
          </tr>
        </thead>
      </table>
      <hr class="pdf-liner" />
      <h2 class="pdf-center">PAYMENT</h2>
      <table class="table">
        <tbody>
          <tr v-for="(item, index) in rowdata.payments" :key="index">
            <td class="col-50">{{ item.name }}</td>
            <td class="col-50 text-right">{{ item.amount }}</td>
          </tr>
          <tr>
            <td colspan="2">Total items: {{ rowdata.total_item }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js';

/**
 * Sorts an array of objects by a specified member (property).
 * @param {Array<Object>} arr - The array of objects to sort.
 * @param {string} member - The object property to sort by.
 * @param {string} [order='asc'] - The sort order: 'asc' or 'desc'.
 * @returns {Array<Object>} - The sorted array.
 */
function sortObjectArray(arr, member, order = 'asc') {
  if (!Array.isArray(arr) || !arr.length || typeof member !== 'string') {
    return arr;
  }

  const sortedArr = [...arr];

  const isNumber = arr.every(obj => {
    const value = obj[member];
    return typeof value === 'number' || (typeof value === 'string' && !isNaN(parseFloat(value)));
  });

  sortedArr.sort((a, b) => {
    let valA = a[member];
    let valB = b[member];

    if (valA == null) return 1;
    if (valB == null) return -1;

    if (isNumber) {
      valA = parseFloat(valA);
      valB = parseFloat(valB);
      return order === 'asc' ? valA - valB : valB - valA;
    } else {
      valA = String(valA).toLowerCase();
      valB = String(valB).toLowerCase();
      return order === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valB);
    }
  });

  return sortedArr;
}

export default {
  name: 'PdfReceipt',
  props: {
    filename: {
      type: String,
      default: 'document.pdf',
    },
    buttonContent: {
      type: String,
      default: 'Download PDF Receipt',
    },
    rowdata: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // rowdata: {
      //   name: "Mott 32 Toronto",
      //   addr: "190 unviersity Ave.",
      //   city: "Toronto, ON, M5H 0A3",
      //   tel: "TEL: 123-456-7890",
      //   taxno: "HST# 12345678",
      //   tableno: "#201",
      //   date: "2025-30-04",
      //   time: "2:17:06 PM",
      //   type: "Sale",
      //   terminal: "1",
      //   cashier: "John Hill",
      //   invoiceno: "1234434534534",
      //   items: [
      //     {
      //       qty: "1",
      //       name: "asda asda asdasd asdasdad asdasdasd adasd",
      //       amount: "$10000.00",
      //     },
      //     {
      //       qty: "2",
      //       name: "asda asda asdasd adasd",
      //       amount: "$1.00",
      //     },
      //     {
      //       qty: "10",
      //       name: "asda asdasdad asdasdasd adasd",
      //       amount: "$1.00",
      //     },
      //     {
      //       qty: "5",
      //       name: "asdasdad asdasdasd adasd",
      //       amount: "$100.00",
      //     },
      //     {
      //       qty: "1",
      //       name: "asda asda asdasd asdasdad asdasdasd adasd",
      //       amount: "$3579.00",
      //     },
      //   ],
      //   totals: [
      //     {
      //       name: "Sub Total:",
      //       amount: "$2000.00"
      //     },
      //     {
      //       name: "Service Charge(21%):",
      //       amount: "$20.00"
      //     },
      //     {
      //       name: "HST:",
      //       amount: "$200.00"
      //     },
      //   ],
      //   total: "$34567.00",
      //   payments: [
      //     {
      //       name: "American Express",
      //       amount: "45566.00"
      //     },
      //     {
      //       name: "Master",
      //       amount: "456.00"
      //     }
      //   ],
      //   total_item: 79
      // },
      data: [
        { name: 'Alice', score: 95.5 },
        { name: 'Bob', score: 88.0 },
        { name: 'Charlie', score: '92.3' },
        { name: 'David', score: 100 },
      ],
      isname2: false,
      sortMember: 'score',
      sortOrder: 'desc',
    };
  },
  computed: {
    sortedData() {
      return sortObjectArray(this.data, this.sortMember, this.sortOrder);
    },
  },
  methods: {
    exportToPDF() {
      const element = this.$refs.pdfContent;
      const opt = {
        margin: 0.5,
        filename: this.filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
      };

      html2pdf()
        .set(opt)
        .from(element)
        .save()
        .then(() => {
          console.log('PDF exported successfully');
        })
        .catch((error) => {
          console.error('PDF export failed:', error);
        });
    },
  },
};
</script>

<style scoped>
.pdf-container {
  width: 100%;
  /* max-width: 8.5in; Letter size width */
  margin: 0 auto;
  padding: 0;
  background: white;
  box-sizing: border-box;
}

.pdf-center {
  text-align: center;
}

h2 {
  margin-bottom: 0;
  line-height: 1.4rem;
  font-size: 1.2rem;
}
.pdf-liner {
  height:2px;
  border-width:0;
  color:gray;
  background-color:gray;
  margin: 0;
}
.pdf-liner2 {
  height:1px;
  border-width:0;
  color:gray;
  background-color:gray;
  margin: 0;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto; /* Center table within container */
  table-layout: fixed; /* Ensure column widths are respected */
}

.table th,
.table td {
  border: 0;
  padding: 0;
  font-size: 1rem;
  text-align: left;
  text-wrap: auto;
}

.table th {
  background-color: #f2f2f2;
  border-bottom: 1px solid grey;
  padding-left: 0;
  padding-right: 0;
  text-transform: unset;
}

/* Column widths */
.col-50 {
  width: 50%;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.col-id {
  width: 10%;
}

.col-name {
  width: 67%;
}

.col-score {
  width: 23%;
}

.btn-primary {
  padding: .5rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: .25rem;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #0056b3;
}

/* Print-specific styles */
@media print {
  .btn-primary {
    display: none; /* Hide button in print */
  }
  .pdf-container {
    margin: 0;
    padding: 0;
  }
}
</style>
